import graphql from './graphql';

const query = /* GraphQL */ `
  query EvaluationAnswer_list($evaluationQuestionId: ID) {
    EvaluationAnswer_list(evaluationQuestionId: $evaluationQuestionId) {
      id
      response
      isCorrect
      order
    }
  }
`;

const EvaluationAnswerList = async ({ evaluationQuestionId }) =>
  graphql(query, { evaluationQuestionId }).then(
    // eslint-disable-next-line camelcase
    ({ EvaluationAnswer_list }) => EvaluationAnswer_list
  );

export default EvaluationAnswerList;
